export interface StatusDataType {
  key: string;
  definition: string;
  status: string;
}

export const STATUS_LIST = [
  'EtudeEnCours',
  'OffreEmise',
  'OffreAcceptee',
  'ChantierEnCours',
  'DocumentsEnAttente',
  'EnCoursDeValidation',
  'Incomplet',
  'EnAttenteDeControle',
  'Valide',
  'Termine',
  'Refuse',
  'Abandon',
] as const;
